"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENVS = exports.PRODUCTION_ENV = exports.HOMOLOG_ENV = exports.DEVELOPMENT_ENV = void 0;
exports.DEVELOPMENT_ENV = {
    API_URL: 'https://fidc-agreement-api.testzz.ninja',
    FIDC_URL: 'https://fidc-agreement.testzz.ninja',
    CONFIG_URL: 'https://website-fidc-front.s3.amazonaws.com'
};
exports.HOMOLOG_ENV = {
    API_URL: 'https://fidc-agreement-api.testzz.ninja',
    FIDC_URL: 'https://fidc-agreement.testzz.ninja',
    CONFIG_URL: 'https://website-fidc-front.s3.amazonaws.com'
};
exports.PRODUCTION_ENV = {
    API_URL: 'https://fidc-agreement-api.eduzz.com',
    FIDC_URL: 'https://fidc-agreement.eduzz.com',
    CONFIG_URL: 'https://website-fidc-front.s3.amazonaws.com'
};
exports.ENVS = {
    development: exports.DEVELOPMENT_ENV,
    homolog: exports.HOMOLOG_ENV,
    production: exports.PRODUCTION_ENV
};
